import { Navigate } from 'react-router-dom'

const FIRST_VISIT_KEY = 'hasVisitedBoot'

export default function RootRedirect() {
  const hasVisited = localStorage.getItem(FIRST_VISIT_KEY)
  const isLoggedIn = localStorage.getItem('token') // 检查是否已登录
  
  // 优先判断登录状态
  if (isLoggedIn) {
    // 已登录用户直接进入首页，不管是否访问过引导页
    return <Navigate to="/home" replace />
  }
  
  // 未登录用户：根据是否访问过引导页决定
  if (!hasVisited) {
    return <Navigate to="/boot" replace />
  }
  
  return <Navigate to="/login" replace />
}
